export { default as WaitingTimeGrids } from './waitingTimeGrids.container';
